import(/* webpackMode: "eager" */ "/codebuild/output/src1065581005/src/apps/wrap.gifts/node_modules/next/dist/client/link.js");
